import { Fragment } from 'react';
import { FormField } from '@direct-frontend/components';
import { type BaseValidationError, type ScrollFieldProps } from '@adv-frontend/form-kit';
import { type CourierAddressFieldValue } from '../../model/forms/fieldCourierAddress';
import { type OrderFormContext } from '../../model/forms/orderForm';
import { buildErrorMessage } from '../../OrderForm';
import { CourierAddressInput } from '../CourierAddressInput';

interface CourierAddressSelectProps {
    isCourierDeliveryMethod: boolean;
    context: OrderFormContext;
    fieldLocalityValue: string;
    fieldAddressCourierValue: CourierAddressFieldValue;
    setValue: (value: CourierAddressFieldValue) => void;
    errors: BaseValidationError[];
    scrollProps?: ScrollFieldProps;
    openRegistrationOzon: VoidFunction;
}

export const CourierAddressSelect = (props: CourierAddressSelectProps) => {
    const {
        isCourierDeliveryMethod,
        context,
        fieldLocalityValue,
        fieldAddressCourierValue,
        setValue,
        errors,
        scrollProps,
        openRegistrationOzon,
    } = props;

    const { order } = context;

    if (!isCourierDeliveryMethod) {
        return null;
    }

    return (
        <Fragment>
            <FormField size="s" errorMessage={buildErrorMessage(errors)} {...scrollProps}>
                {(fieldProps) => (
                    <CourierAddressInput
                        {...fieldProps}
                        size="m"
                        placeholder="Адрес доставки"
                        order={order}
                        storeSlug={context.storeSlug}
                        locality={fieldLocalityValue}
                        value={fieldAddressCourierValue}
                        onChange={setValue}
                        openRegistrationOzon={openRegistrationOzon}
                        validationState={buildErrorMessage(errors) ? 'invalid' : 'valid'}
                    />
                )}
            </FormField>
        </Fragment>
    );
};
